import PropTypes from 'prop-types';
import React from 'react';
import { StyledInputContainer } from './styles';

const RadioInputWithImage = ({
  imageAlt,
  imageSrc,
  labelText,
  name,
  onClick,
  value,
}) => {
  return (
    <StyledInputContainer>
      <input
        className="radio-input"
        id={value}
        name={name}
        onClick={onClick}
        type="radio"
        value={value}
      />
      <label
        className="d-flex mb-0 py-md-5 px-3 w-100 align-items-center"
        htmlFor={value}
      >
        <span className="visual-radio mr-3"></span>
        {labelText}
        <img
          src={imageSrc}
          alt={imageAlt}
          width="50"
          height="50"
          className="ml-auto"
        />
      </label>
    </StyledInputContainer>
  );
};

RadioInputWithImage.propTypes = {
  imageAlt: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default RadioInputWithImage;
